import { useState } from "react";
import { X, CheckCircle, CaretDown, CaretUp } from "@phosphor-icons/react";
import { useOnboarding } from "@/hooks/useOnboarding";
import { ONBOARDING } from "@/lib/onboarding-config";

export default function OnboardingBanner({ pageKey }) {
  const config = ONBOARDING[pageKey];
  const { isDone, markDone } = useOnboarding(pageKey);
  const [expanded, setExpanded] = useState(false);

  if (!config || isDone()) return null;

  return (
    <div className="mb-5 bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border border-amber-200 dark:border-amber-700/50 rounded-2xl p-4 relative">
      <button
        onClick={() => markDone()}
        className="absolute top-1 right-1 min-h-[44px] min-w-[44px] flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition"
        aria-label="Dismiss guide"
      >
        <X size={15} />
      </button>

      <div className="flex items-start gap-3 pr-6">
        <div className="bg-amber-400 text-white rounded-lg p-1.5 shrink-0 mt-0.5">
          <CheckCircle size={15} weight="bold" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-widest text-amber-600 dark:text-amber-400 mb-0.5">Quick Start Guide</p>
          <h3 className="font-semibold text-slate-800 dark:text-slate-100 text-sm">{config.title}</h3>

          {expanded && (
            <ol className="mt-2.5 space-y-1.5">
              {config.steps.map((step, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-600 dark:text-slate-300">
                  <span className="text-amber-500 font-bold text-xs mt-0.5 shrink-0 w-4">{i + 1}.</span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          )}

          {!expanded && (
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{config.steps[0]}</p>
          )}

          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={() => setExpanded(e => !e)}
              className="text-xs min-h-[44px] text-amber-600 dark:text-amber-400 hover:text-amber-700 font-semibold flex items-center gap-1 transition"
            >
              {expanded ? (
                <><CaretUp size={11} weight="bold" /> Show less</>
              ) : (
                <><CaretDown size={11} weight="bold" /> Show all {config.steps.length} steps</>
              )}
            </button>
            <button
              onClick={() => markDone()}
              className="ml-auto text-xs bg-amber-400 hover:bg-amber-500 text-white font-semibold px-3 min-h-[44px] rounded-lg transition"
            >
              Got it ✓
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
